// REACT
import { useContext, useEffect, useState } from "react";

// CONTEXT & ASSETS
import { maincontext } from "../../context/maincontext";

// CUSTOM HOOKS
import { useRead } from "../../hooks/useFetch";

// COMPONENTS
import SingleConflict from "./SingleConflict";
import Loading from "../common/Loading";

// ASSETS
import Table from "react-bootstrap/Table";
import "../../assets/styles/conflictsList.css";
import languagePack from "../../assets/languages/languagePack";

export default function UnresolvedConflicts(props) {
    const { language, token } = useContext(maincontext);

    // MODAL
    const [showModal, setShowModal] = useState(false);
    const [modalItem, setModalItem] = useState(null);

    // RENDER VARS
    const [groupedConflicts, setGroupedConflicts] = useState()

    // URL & Fetch Hooks
    const [refetchTrigger, setRefetchTrigger] = useState(false);

    const conflictsUrl = `${process.env.REACT_APP_BACKEND_BASE_URL}conflicts`;
    const conflicts = useRead(conflictsUrl, refetchTrigger)

    // Group by distributor
    useEffect(() => {
        if (conflicts.data && !conflicts.data.isPending) {
            // const groupedConflicts =
            setGroupedConflicts(conflicts.data.reduce((acc, conflict) => {
                const group = conflict.distributor || "Unknown Distributor";
                if (!acc[group]) acc[group] = [];
                acc[group].push(conflict);
                return acc;
            }, {}))
        }
    }, [conflicts.data, conflicts.error, conflicts.isPending])

    return (
        <>
            {!token || conflicts.isPending ?
                <Loading /> :
                <>
                    {showModal && <>{modalItem}</>}
                    {conflicts.error && <h4 className="conflictError">{conflicts.error}</h4>}

                    {groupedConflicts && Object.keys(groupedConflicts).length === 0 && !conflicts.error &&(
                        <h4 className="noCoflict">{languagePack[language].conflictResolver.noCoflict}</h4>
                    )}

                    <div className="table-container">
                        {groupedConflicts &&
                            Object.entries(groupedConflicts).map(([distributor, entries]) => (
                                <div key={distributor} className="conflict-group">
                                    <h3>{distributor}</h3>
                                    <div className="table-scroll">
                                        <Table
                                            striped
                                            bordered
                                            hover
                                            responsive
                                            className={`conflict-table ${props.isResolved ? "resolved-mode" : "unresolved-mode"}`}
                                        >
                                            <thead>
                                                <tr>
                                                    <th>{languagePack[language].conflictResolver.conflictingName}</th>
                                                    <th>{languagePack[language].conflictResolver.actions}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {entries.map(conflict => (
                                                    <SingleConflict
                                                        key={conflict.product_name}
                                                        conflict={conflict}
                                                        setShowModal={setShowModal}
                                                        setModalItem={setModalItem}
                                                        setRefetchTrigger={setRefetchTrigger}
                                                    />
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            ))}
                    </div>
                </>
            }
        </>
    );
}
